import { generateChoices } from './generate_choices'

document.addEventListener('turbolinks:load', (event) => {
  const elements = document.querySelectorAll('.js-choice')
  window.jsChoices = []
  elements.forEach((el, i) => {
    generateChoices(el, el)
  })
})
